// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  font-size: 16px;
  margin: 0;
  color: #3e5777;
  border-bottom: 1px solid #3e5777;
  padding-bottom: 2px;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/base/field/fieldA.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,SAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;AACJ","sourcesContent":["p {\n    font-size: 16px;\n    margin: 0;\n    color: #3e5777;\n    border-bottom: 1px solid #3e5777;\n    padding-bottom: 2px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
